import React, { useState } from 'react';
import { formatDateToFullMonthDayYear, BaseButton, useT } from '@repo/common';
import { ReactComponent as CouponIcon } from '@repo/common/assets/icons/20px/icon_20px_payment-coupon_outline.svg';
import { ReactComponent as CopyIcon } from '@repo/common/assets/icons/20px/icon_20px_copy.svg';

const CouponRow = ({ item, currentFilter, onCopy, $isMobile }) => {
  const t = useT();
  const isActive = currentFilter === 'Active';
  const [showCode, setShowCode] = useState(false);

  const handleCopy = () => {
    onCopy?.(item.code);
  };

  return (
    <div className='flex w-full flex-col tabletH:flex-row tabletH:items-center tabletH:min-w-[700px] tabletH:min-h-[146px]'>
      <div className='flex flex-col tabletH:flex-row items-start p-3 tabletH:p-6 gap-2 tabletH:gap-4 bg-grayscale-gray00 rounded-2xl w-full'>
        <div
          className={`flex items-center justify-center size-8 tabletH:size-10 tabletH:p-2.5 gap-2.5 rounded-[100px] ${isActive ? 'bg-green-light01' : 'bg-grayscale-gray01'} ${isActive ? 'text-green-deep02' : 'text-grayscale-gray03'}`}
        >
          <CouponIcon className='w-5 h-5 p-0.5' />
        </div>
        <div className='flex flex-1 flex-col items-start justify-center tabletH:py-1.5 gap-0.5 tabletH:gap-2'>
          <div className='typo-b14Strong tabletH:typo-title2 text-text-primary'>
            {item.title}
          </div>
          <div className='typo-b11 tabletH:typo-b16Strong text-text-placeholder'>
            {item.content}
          </div>
          <div className='typo-b11Strong tabletH:typo-b14Strong text-text-placeholder'>
            {t('Valid until', '사용 기한:')}{' '}
            {formatDateToFullMonthDayYear(item.expireDate)}
          </div>
        </div>
      </div>

      <div
        className='tabletH:hidden w-full'
        style={{
          height: '1.6px',
          backgroundImage:
            'repeating-linear-gradient(to right, #ECE9E4 0px, #ECE9E4 5px, transparent 5px, transparent 10px)',
        }}
      />

      <div
        className='hidden tabletH:block'
        style={{
          width: '1.6px',
          minHeight: '114px',
          backgroundImage:
            'repeating-linear-gradient(to bottom, #ECE9E4 0px, #ECE9E4 5px, transparent 5px, transparent 10px)',
        }}
      />

      <div className='flex items-center justify-center p-3 tabletH:p-[30px] bg-grayscale-gray00 rounded-2xl w-full tabletH:max-w-[234px] tabletH:h-full tabletH:min-h-[146px] group'>
        {showCode ? (
          <BaseButton
            type='text_basic'
            size={$isMobile ? 'l' : 'xl'}
            icon={<CopyIcon />}
            iconPosition='after'
            onClick={handleCopy}
            width='100%'
            bgclass='tabletH:py-[14px] pl-4 pr-3 bg-grayscale-gray00'
          >
            {item.code}
          </BaseButton>
        ) : (
          <BaseButton
            hideIcon
            type='text'
            size={$isMobile ? 'l' : 'xl'}
            onClick={() => isActive && setShowCode(true)}
            width='100%'
            isDisabled={!isActive}
          >
            {isActive
              ? t('View Code', '코드 보기')
              : t('Expired', '만료됨')}
          </BaseButton>
        )}
      </div>
    </div>
  );
};

export default CouponRow;
